module.exports = __webpack_public_path__ + "img/niunai2.72aee62d.jpg";